export const AGENT_OUTCOME_COPY = {
  sectionTitle: 'Measure agent outcomes',
  sectionSubtitle: 'Count successful tool runs as metrics and link them to the records they create.',
  controlsLegend: 'Measurement options',
  enableLabel: 'Track successful runs',
  enableDescription: 'Count every successful run as a metric you can report on in Reach.',
  linkResourceLabel: 'Link each run to the record it creates',
  linkResourceDescription: 'Use the record’s ID to link each successful run to its synced record.',
  schemaLabel: 'Linked record type',
  schemaHint: 'Choose the synced record type this tool creates.',
  missingSchema: 'Choose the record type you want to link.',
  chooseSchema: 'Choose a record type…',
  savedSchema: 'Saved record type',
  savedSchemaUnavailable: 'Saved record type is no longer available',
  unavailableSchema: 'Choose an active record type; the saved record type is no longer available.',
  loadingSchemas: 'Loading synced record types…',
  schemaLoadFailure: 'Synced record types could not be loaded.',
  retrySchemaLoad: 'Try again',
  noActiveSchemas:
    "You don't have an eligible synced record type yet. Set one up in Data Integration first, then come back.",
  requiredMappingTitle: 'Link each run to the record it creates',
  requiredMappingDescriptionLead: 'Map the synced record’s ID to',
  requiredMappingDescriptionTail: 'so Reach can link the run to its synced record.',
  requiredMappingSuggestionLead: 'Use',
  requiredMappingSuggestionConnector: 'as',
  requiredMappingSuggestionTail: 'to link the run to its synced record',
  requiredMappingSamplePrompt: 'Run a test or paste a sample response, then choose the record ID.',
  mappedResourceIdHint: 'Required to link the run to its synced record.',
} as const;

export const unreadableAgentOutcomeMessage = (marker: string | undefined): string =>
  marker
    ? `This tool has an unrecognized outcome tracking setting: "${marker}". Turn outcome tracking on or off to replace it.`
    : 'This tool links a record without enabling outcome tracking. Turn outcome tracking on or off to repair it.';

export const requiredAgentOutcomeMappingSuggestion = (
  suggestedPath: string,
  outputName: string,
): string => `Use ${suggestedPath} as ${outputName}`;
